import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c0co3r5w: FaireBrandEntity = {
  token: "b_c0co3r5w",
  type: "brand",
  name: "Purposeful Bliss - Fizzy Magic",
  avatarUrl:
    "https://cdn.faire.com/fastly/3346dc64e8610b19ce3c39e7113d36ec47b241099dcbae2e17a3c1cdb76fa0b2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ec77a94952cee3fbb618833aa0e391a6852a1337ce187f1d1552fb336b40bfdd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3346dc64e8610b19ce3c39e7113d36ec47b241099dcbae2e17a3c1cdb76fa0b2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ec77a94952cee3fbb618833aa0e391a6852a1337ce187f1d1552fb336b40bfdd.jpeg",
  location: "Batavia , IL, USA",
  minimumOrderDollars: 40,
  rating: 4.9,
  reviewCount: 69,
  isTopShop: true,
  isInsider: true,
  description:
    "My son Lane is the spark behind Fizzy Magic.\nWhile shopping for teacher gifts, Lane asked a store clerk if her bath fizzies had toys inside. When she said no, he replied, “Why not?” That simple question lit up my curiosity and planted the seed for something more meaningful.\nWhat began as a playful idea quickly grew into a mission: to create a product that deepens the connection between parent and child at bath time, while delivering the fun kids crave. In 2018, I launched the first educational bath fizzy—with a surprise inside and a clue to guess it, plus fun facts and a bedtime story tied to the toy.\nEven better? Fizzy Magic is free from synthetic fragrances, nut oils, sodium lauryl sulfate, and other harsh ingredients found in many bath products. Because what goes on your child’s skin should be just as thoughtful as what goes into their imagination.\nSince our 2018 launch, we’ve continued to expand with joyful innovations that transform bath time into learning time:\n- 🌋 Patented Bubbling Water Toy – featuring the erupting Volcano and enchanting Castle\n- 🎀 On-Trend Surprise Toys – including collectable Mochi squishies, playful Necklaces, and colorful Charms\n- 🎁 3X Giant Fizzies – a sibling-friendly pack with multiple surprises\nOur mission remains simple yet powerful: to reinvent bath time as a moment of magic, discovery, and connection.\nMary Westerhaus\nFounder & CEO, Fizzy Magic\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:22.332Z",
    importedBy: "entity-db-cli",
  },
};
